<template>
  <div class="w-100">
    <div class="d-inline-flex">
      <el-button type="default" icon="el-icon-arrow-down" size="mini" @click="requestToggleToolbar"></el-button>

      <el-tabs v-model="tab" @tab-click="onTabChanged" class="pl-4">
        <el-tab-pane label="所有" name="all"></el-tab-pane>
        <el-tab-pane label="未完成" name="pending"></el-tab-pane>
        <el-tab-pane label="已完成" name="completed"></el-tab-pane>
        <el-tab-pane label="已取消" name="rejected"></el-tab-pane>
        <!-- eslint-disable-next-line -->
        <el-tab-pane label="" name="search"></el-tab-pane>
      </el-tabs>
    </div>
    

    <el-table :data="orderList" v-loading="isLoading" :row-class-name="rowHighlighter"
      :show-header="false" @row-click="onRowClicked">

      <el-table-column prop="order_number" width="108" align="center">
        <template slot-scope="{row}">
          <span class="text-order-number">{{row.order_number}}</span><br>
        </template>
      </el-table-column>

      <el-table-column prop="created_at">
        <template slot-scope="{row}">
          <div class="row text-center px-2">
            <div class="d-flex justify-content-between w-100">
              <div>
                <el-tag type="info" size="small" v-if="row.meal_type === 'eat_in'">內用</el-tag>
                <el-tag type="warning" size="small" v-else-if="row.meal_type === 'to_go'">外帶</el-tag>
                <el-tag type="danger" size="small" v-else-if="row.meal_type === 'delivery'">外送</el-tag>
              </div>
              <strong class="text-order-amount">${{Number(row.amount).toLocaleString()}}</strong>
            </div>
            <el-divider></el-divider>
            <span class="w-100 text-right">{{(row.lala_take_meal_time || row.take_meal_time) | toDateString}}</span>
          </div>
        </template>
      </el-table-column>

      <!-- STATUS -->
      <el-table-column prop="status" width="96" align="right">
        <template slot-scope="{row}">
          <badge type="warning" class="Blink" v-if="!row.read">新訂單</badge>
          <badge type="default" v-else-if="row.read && row.status === 'accepted'">製作中</badge>
          <badge type="danger" v-else-if="row.read && row.status === 'rejected'">已取消</badge>
          <badge type="danger" v-else-if="row.read && row.status === 'cancelled'">已取消</badge>
          <badge type="default" v-else-if="row.read && row.status === 'lala_rejected'">物流取消</badge>
          <badge type="success" v-else-if="row.read && row.status === 'done'">完成</badge>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
import { fsdb } from '../../firestore';
import moment from 'moment';

import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faBan, faExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faCheckCircle, faBan, faExclamation);

import { Badge } from 'src/components';

export default {
  name: 'PosOrderList',
  components: {
    "font-awesome-icon": FontAwesomeIcon,
    [Badge.name]: Badge
  },
  props: {
    shopId: Number,
    orders: Array,
    isLoading: Boolean,

    search: String,
    sort: {
      type: String, default: 'created_at:desc'
    }
  },

  mounted() {
    console.log(this.orders);
  },

  methods: {
    onTabChanged(tab) {
      console.log('onTabChanged', tab);
    },

    onRowClicked(row) {
      //FIXME: Ensure this row has been "read".
      this.selectedRow = row;
      this.markRead(row);
      this.$emit('select', row);
    },

    /// Methods for updating per-order status.
    markRead(order) {
      if (!order.is_cancelled && !order.read) {
        fsdb.doc(`shops/${this.shopId}/orders/${order.id}`)
          .set({read: true}, {merge: true})
          .then(() => {})
          .catch(err => {});
      }
    },
    toggleCompleted(order) {
      fsdb.doc(`shops/${this.shopId}/orders/${order.id}`)
        .set({completed: !order.completed}, {merge: true})
        .then(() => {})
        .catch(err => {});
    },

    //NOTE: This should highlights the selected row.
    rowHighlighter(args) {
      if (this.selectedRow) {
        if (this.selectedRow.id === args.row.id)
          return 'row-lighted';
      }
      return '';
    },

    requestToggleToolbar() {
      this.$emit('toggle-toolbar');
    }
  },

  data() {
    return {
      tab: 'all',

      filter: '',
      selectedRow: undefined
    }
  },

  computed: {
    orderList() {
      let tokens = this.sort.split(':');
      let sortBy = tokens[0], asc = (tokens[1] === 'asc');
      let ret = [];

      // Do filtering (by tab)
      ret = this.orders.filter(o => {
        //FIXME: Get rid of future orders (for now).
        if (o.take_meal_time >= moment().add(1, 'days').startOf('day').unix())
          return false;

        switch (this.tab) {
          case 'pending': return o.status === 'new' || o.status === 'accepted';
          case 'completed': return o.status === 'done';
          case 'rejected': return o.status === 'rejected' || o.status === 'cancelled';
          case 'search': {
            let odn = parseInt(this.search);
            if (isNaN(odn) || odn <= 0)
              return true;
            return o.order_number === parseInt(this.search);
          }
          default: return true;
        }
      });

      return ret.slice(0).sort((a, b) => {//NOTE: .slice(0) is practically cloning the array.
        if (asc)
          return a[sortBy] - b[sortBy];
        return b[sortBy] - a[sortBy];
      });
    }
  },

  watch: {
    search: {
      immediate: false,
      handler(keyword) {
        if (!keyword.length) {
          this.tab = 'all';
          return;
        }
        this.tab = 'search';//A hidden tab.
      }
    }
  },

  filters: {
    toDateString: ts => {
      return moment.unix(ts).format('M/DD h:mmA');
    }
  }
}
</script>

<style scoped>
.order-icon {
  font-size: xx-large;
}
.order-icon[icon="check-circle"] {
  color: green;
}
.text-order-number {
  font-weight: bold;
  font-size: xx-large;
}
.text-order-amount {
  font-size: large;
}

.el-divider {
  margin: 0 0;
}

.Blink {
  animation: blinker 0.75s cubic-bezier(.5, 0, 1, 1) infinite alternate;  
}
.Blink-danger {
  animation: blinker 0.25s cubic-bezier(.5, 0, 1, 1) infinite alternate;  
}
@keyframes blinker {  
  from { opacity: 1; }
  to { opacity: 0; }
}
</style>

<style>
.row-lighted {
  background-color: lightblue !important;
}
.no-x-padding {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>